import React from "react";
import { OrderCard } from "./UI/OrderCard";
import { OrderTable } from "./UI/OrderTable";
import { ViewState, ValidateState } from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";
import { MVVMValidateDialog } from "../Common/MVVMValidateDialog";

export class OrderView extends React.Component {
  render() {
    return (
      <div>
        <div
          className="ui-g dashboard"
          style={this.props.loading === true ? { pointerEvents: "none" } : {}}
        >
          {this.props.viewState === ViewState.CARD && (
            <React.Fragment>
              <MVVMValidateDialog
                header="Order"
                isVisible={this.props.validateState === ValidateState.CONFIRM}
                visibleField="validateState"
                updateVisibility={this.props.updateState}
                runConfirm={this.props.discardChanges}
                message={"Discard Changes?"}
              />
              <MVVMValidateDialog
                header="Delete Order"
                isVisible={this.props.validateState === ValidateState.DELETE}
                visibleField="validateState"
                updateVisibility={this.props.updateState}
                message={" Are you sure you want to delete?"}
                type={"CRUDL"}
                crudlExecute={this.props.crudlExecute}
                crudlState={this.props.crudlState}
              />
              <pr.Sidebar
                visible={true}
                fullScreen={true}
                onHide={e => {
                  this.props.discardChanges();
                }}
              >
                <OrderCard
                  loading={this.props.loading}
                  crudlState={this.props.crudlState}
                  crudlControl={this.props.crudlControl}
                  updateValue={this.props.updateEdited}
                  updateState={this.props.updateState}
                  editedObject={this.props.editedObject}
                  checkRequiredFields={this.props.checkRequiredFields}
                  discardChanges={this.props.discardChanges}
                  validateState={this.props.validateState}
                  validateChanges={this.props.validateChanges}
                  crudlExecute={this.props.crudlExecute}
                  menuState={this.props.menuState}
                  orderTableColumns={this.props.orderTableColumns}
                  orderExpandedRows={this.props.orderExpandedRows}
                  orderList={this.props.orderList}
                  customerOptions={this.props.customerOptions}
                  deletedOrderItemList={this.props.deletedOrderItemList}
                  //PRODUCT SPECIFIC PROPS
                  productList={this.props.productList}
                  productTableColumns={this.props.productTableColumns}
                  productExpandedRows={this.props.productExpandedRows}
                  productAddModal={this.props.productAddModal}
                  hideProductEditor={this.props.hideProductEditor}
                  removeProductFromSelectedProducts={
                    this.props.removeProductFromSelectedProducts
                  }
                  updateProductSelected={this.props.updateProductSelected}
                  customerList={this.props.customerList}
                />
              </pr.Sidebar>
            </React.Fragment>
          )}
          {this.props.viewState === ViewState.TABLE && (
            <React.Fragment>
              <OrderTable
                //CUSTOMISATION
                tableReference={this.props.tableReference}
                tableColumns={this.props.tableColumns}
                columnOptions={this.props.columnOptions}
                columnToggle={this.props.columnToggle}
                expandedRows={this.props.expandedRows}
                rowCount={this.props.rowCount}
                settingsToggle={this.props.settingsToggle}
                //

                updateState={this.props.updateState}
                orderList={this.props.orderList}
                crudlControl={this.props.crudlControl}
                validateState={this.props.validateState}
                menuState={this.props.menuState}
                crudlState={this.props.crudlState}
                loading={this.props.loading}
                refresh={this.props.refresh}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Orders/OrderView.js